import ExcelUploadComponent from '../components/CourseManagement';

import React, { useState } from 'react';


const AudioCourseAdmin = () => {
  const [activeTab, setActiveTab] = useState('upload');

  const handleUploadSuccess = () => {
    console.log('Course uploaded successfully!');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: 'white', padding: '1rem 2rem', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <h1></h1>
        <ExcelUploadComponent />

      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
       
        

        
        
      </div>
    </div>
  );
};

export default AudioCourseAdmin;